import { useGetCompanyDetailQuery } from 'pages/admin/companies/queries';

import { useGetCompanyAndUserInfoQuery, useGetCountriesQuery } from './queries';

const getSystemTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
};

/**
 * Returns the logged user's company timezone ID (IANA, e.g. "Europe/Prague").
 * Sourced from cached LoggedUserInfo query.
 */
export const useUserTimezone = (): string => {
  const companyAndUserQuery = useGetCompanyAndUserInfoQuery();

  return companyAndUserQuery.data?.company.timezoneId || getSystemTimezone();
};

/**
 * Resolves timezone ID for a specific company.
 *
 * Flow:
 * 1) load company detail by companyId,
 * 2) read company countryId,
 * 3) map countryId to timezoneId using countries list.
 */
const useCompanyTimezoneId = (companyId: string): string => {
  const companyDetailQuery = useGetCompanyDetailQuery(companyId);
  const countriesQuery = useGetCountriesQuery();

  const companyCountryId = companyDetailQuery.data?.countryId;
  const companyCountry = countriesQuery.data?.find((country) => country.id === companyCountryId);

  return companyCountry?.timezoneId || getSystemTimezone();
};

export default useCompanyTimezoneId;
